import script from "./AddCommission.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCommission.vue?vue&type=script&setup=true&lang=js"

import "./AddCommission.vue?vue&type=style&index=0&id=423c6572&lang=css"

export default script